import { combineReducers } from 'redux'

import {
  appNotificationSettings,
  appNotificationSettingsPending,
  appNotificationSettingsLoaded,
  appNotificationSettingsUpdates
} from './appNotificationSettings'
import { appFeatures } from "./appFeatureSettings"
import { appContent, appContentPending } from './appContentSettings'
import { appContentLanguage } from './appContentLanguage'

export { default as sagas } from './sagas'

export const FETCH_APP_CONTENT = 'FETCH_APP_CONTENT'
export const FETCH_APP_CONTENT_SUCCEEDED = 'FETCH_APP_CONTENT_SUCCEEDED'
export const FETCH_APP_CONTENT_FAILED = 'FETCH_APP_CONTENT_FAILED'
export const SET_APP_CONTENT_LANGUAGE = 'SET_APP_CONTENT_LANGUAGE'
export const SET_STATIC_APP_CONTENT = 'SET_STATIC_APP_CONTENT'

export const FETCH_FEATURE_SETTINGS = 'FETCH_FEATURE_SETTINGS'
export const FETCH_FEATURE_SETTINGS_SUCCEEDED = 'FETCH_FEATURE_SETTINGS_SUCCEEDED'
export const FETCH_FEATURE_SETTINGS_FAILED = 'FETCH_FEATURE_SETTINGS_FAILED'

export const FETCH_NOTIFICATION_SETTINGS = 'FETCH_NOTIFICATION_SETTINGS'
export const FETCH_NOTIFICATION_SETTINGS_SUCCEEDED = 'FETCH_NOTIFICATION_SETTINGS_SUCCEEDED'
export const FETCH_NOTIFICATION_SETTINGS_FAILED = 'FETCH_NOTIFICATION_SETTINGS_FAILED'

export const POST_NOTIFICATION_SETTINGS = 'POST_NOTIFICATION_SETTINGS'
export const POST_NOTIFICATION_SETTINGS_SUCCEEDED = 'POST_NOTIFICATION_SETTINGS_SUCCEEDED'
export const POST_NOTIFICATION_SETTINGS_FAILED = 'POST_NOTIFICATION_SETTINGS_FAILED'

export const UPDATE_NOTIFICATION_SETTING = 'UPDATE_NOTIFICATION_SETTING'
export const UPDATE_NOTIFICATION_SETTING_SUCCEEDED = 'UPDATE_NOTIFICATION_SETTING_SUCCEEDED'
export const UPDATE_NOTIFICATION_SETTING_FAILED = 'UPDATE_NOTIFICATION_SETTING_FAILED'

export const setAppContentToState = (appContent) => {
  const action = {
    type: FETCH_APP_CONTENT_SUCCEEDED,
    payload: appContent,
  };
  return action;
};

export const setStaticAppContent = (appContent) => {
  const action = {
    type: SET_STATIC_APP_CONTENT,
    payload: appContent,
  };
  return action;
};

export const fetchAppContent = () => {
  return {
    type: FETCH_APP_CONTENT,
  }
}

export const setAppContentLanguage = (language) => ({
  type: SET_APP_CONTENT_LANGUAGE,
  payload: language,
})

export const fetchAppFeatures = () => {
  return {
    type: FETCH_FEATURE_SETTINGS,
  }
}

export const setAppFeaturesToState = (appFeatures) => {
  const action = {
    type: FETCH_FEATURE_SETTINGS_SUCCEEDED,
    payload: appFeatures,
  };
  return action;
};

export const fetchNotificationSettings = () => ({
  type: FETCH_NOTIFICATION_SETTINGS,
})

export const postNotificationSettings = () => ({
  type: POST_NOTIFICATION_SETTINGS,
})

export const updateNotificationSetting = (previousValue, newValue, valueRef) => ({
  type: UPDATE_NOTIFICATION_SETTING,
  previousValue,
  newValue,
  valueRef,
})

export const getAppContent = (appSettings) => appSettings.appContent
export const getOnboardingSlides = (appSettings) => appSettings.appContent?.onboarding.slides.slideContent
export const isAppContentPending = (appSettings) => appSettings.appContentPending
export const getAppContentLanguage = (appSettings) => appSettings.appContentLanguage

export const getAppFeatures = (appSettings) => appSettings.appFeatures

export const getAppNotificationSettings = (appSettings) => appSettings.appNotificationSettings
export const getAppNotificationSettingsObject = (appSettings) => Object.values(appSettings.appNotificationSettings)
export const isAppNotificationSettingsPending = (appSettings) => appSettings.appNotificationSettingsPending
export const hasAppNotificationSettingsLoaded = (appSettings) => appSettings.appNotificationSettingsLoaded
export const hasAppNotificationSettingsUpdates = (appSettings) => Object.values(appSettings.appNotificationSettingsUpdates).length > 0

export default combineReducers({
  appContent,
  appContentPending,
  appContentLanguage,
  appFeatures,
  appNotificationSettings,
  appNotificationSettingsPending,
  appNotificationSettingsLoaded,
  appNotificationSettingsUpdates,
})
